import { AbstractNetworkPrintingAdapter } from './AbstractNetworkPrintingAdapter';
import { INetworkPrintingConfig, IGetPrinterDPIConfig, IGetPrinterDPIResult } from '../NetworkPrintingTypes';

/**
 * Cross-frame implementation of network printing adapter.
 * Placeholder for future ATBase integration.
 *
 * This adapter will eventually use ATBaseClient for cross-frame communication
 * to target 'networkPrintingListener' in ATBase when support is added.
 */
export class CrossFrameNetworkPrintingAdapter extends AbstractNetworkPrintingAdapter {
    /**
     * Prints ZPL data to a network printer using cross-frame communication.
     * Currently returns a rejected promise as a placeholder for future ATBase integration.
     *
     * @param config - Configuration object containing printer IP, ZPL data, and optional port
     * @returns Promise that rejects with "Method not implemented" error
     */
    public print(config: INetworkPrintingConfig): Promise<any> {
        // Log for debugging purposes
        console.log('CrossFrameNetworkPrintingAdapter: Method not yet implemented - placeholder for future ATBase integration');

        // Return rejected promise with "Method not implemented" error as specified in requirements
        return Promise.reject(new Error('Method not implemented'));
    }

    /**
     * Queries the DPI of a network printer using cross-frame communication.
     * Currently returns a rejected promise as a placeholder for future ATBase integration.
     */
    public getPrinterDPI(config: IGetPrinterDPIConfig): Promise<IGetPrinterDPIResult> {
        console.log('CrossFrameNetworkPrintingAdapter: getPrinterDPI not yet implemented');
        return Promise.reject(new Error('Method not implemented'));
    }
}
